<script>
  export default {
    name: "_Admin",
    computed: {
      adminIsEnabled: function () {
        return this.$store.getters['admin/isEnabled']
      }
    },
    beforeMount ()
    {
      let store = this.$store
      let admin = window.iProfesional.admin || false
      store.commit('admin/setContext', admin.enabled || false)
    }
  }
</script>